exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".katex-mathml{display:none}*{font-family:Anonymous Pro}.tappable{cursor:pointer}input.invalid,textarea.invalid{border:1px solid red;background-color:#f6b5b9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/code/global.scss
// module id = 76
// module chunks = 0